<script lang="ts" setup>
  import { ref } from 'vue';
  import { ApiError, reasonOf } from '../../../../shared/api/client.ts';
  import { leaveFeedback } from '../../../../shared/api/feedback.ts';
  import type { GameOverView as GameOver } from '../../../../shared/api/gameOver.ts';
  import GameOverView from './GameOverView.vue';

  defineProps<{ view: GameOver }>();
  const emit = defineEmits<{ changed: [] }>();

  const err = ref<string>('');
  const textErr = ref<string>('');

  const postFeedback = async (feedback: string) => {
    clearFeedbackError();
    try {
      await leaveFeedback(feedback);
    } catch (error) {
      if (error instanceof ApiError && error.slug === 'invalid-body') textErr.value = error.reason;
      else err.value = reasonOf(error);
      return;
    }

    emit('changed');
  };

  const clearFeedbackError = () => {
    err.value = '';
    textErr.value = '';
  };
</script>

<template>
  <GameOverView
    :data="view"
    :error="err"
    :text-error="textErr"
    @feedback="postFeedback"
    @feedback-closed="clearFeedbackError"
  />
</template>
